// App.tsx
import "./App.css";
import Router from "./router/router";
import CssBaseline from "@mui/material/CssBaseline";
// import Router from "./router/router.tsx";
// import {Test1} from "./test1.tsx";


function App() {
    return (
        <>
            <CssBaseline />
            <Router />
        </>
    );
}

export default App;
